import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      camper, // via query
      session, // via query
      redeemablePass, // via component prop
      removeGuestPass // via redux actions
    } = props

    const handleClickRemove = e => {
      removeGuestPass({ camper, session, redeemablePass })
    }

    return <WrappedComponent onClickRemove={handleClickRemove} {...props} />
  }
}

export default withEventHandlers
